import { render, staticRenderFns } from "./AceModule.vue?vue&type=template&id=536b95ab&scoped=true&"
import script from "./AceModule.vue?vue&type=script&lang=js&"
export * from "./AceModule.vue?vue&type=script&lang=js&"
import style0 from "./AceModule.vue?vue&type=style&index=0&id=536b95ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b95ab",
  null
  
)

export default component.exports